import React, { FC, useState, useContext, useEffect, createRef, useMemo, useCallback } from 'react'
import TextareaAutosize from 'react-textarea-autosize'

import { useDispatch, useSelector } from '../../../store'
import PostActionWrapper, { MARK_TYPE } from '../PostActionWrapper/index'
import PostActionTitle from '../PostActionTitle/index'
import PostActionBody from '../PostActionBody/index'
import CustomButton from '../../UI/Buttons/CustomButton'
import Checkbox from '../../UI/Inputs/Checkbox'
import Preloader from '../../Preloader'
import { Can, AbilityContext } from '../../../CASL/Can'
import { AbilityBuilder, Ability } from '@casl/ability'

import { openSchedulePostModal, showApprovalListAction } from '../../../store/application/slice'

import {
  TNewPostSocialNotePayload,
  TPostSocialNoteForList,
  TPostSocialsNotesMapByPostSocialId,
  TPostSocialNoteDeletedDataPayload,
  TPostSocialNoteUpdatedDataPayload,
  TPostSocialsActionsMapByPostSocialId,
  TRequireApproverRevisionPayload,
  TStatusesCheckboxesPayload,
  TPostSocialManagePost,
  TApprovalPostSocialsManagePost,
  TLoadersManagePost
} from '../../../store/managePost/newTypes'
import {
  deletePostSocialNoteThunk,
  savePostSocialNoteThunk,
  updateSocialPostNoteThunk,
  requireApproverRevisionThunk,
  addStatusesToCheckboxesInRevisionBlockThunk,
  publishPostManuallyThunk,
  adminPublishPostManuallyThunk,
  removeAttachmentThunk,
  showAllPostSocialNoteThunk,
  reviseNotesThunk,
  deleteNotesAttachment
} from '../../../store/managePost/thunks'
import {
  ACTION_TYPE,
  APPROVAL_TYPE,
  POST_SOCIAL_STATUS,
  TApprovalPlan,
  TPostSocialNote
} from '../../../models/post'

import CheckBoxIcon from '../../../assets/img/checkbox-icon.svg'
import DeleteIcon from '../../../assets/img/delete-icon.svg'
import CheckCircle from '../../../assets/img/check-circle.svg'
import TrashRed from '../../../assets/img/trash-red.svg'
import EditIcon from '../../../assets/img/edit.svg'
import WaitingIcon from '../../UI/Icons/statuses/Waiting'
import PublishIcon from '../../UI/Icons/statuses/Publish'
import AttachmentIcon from '../../../assets/img/attachment-black.svg'

import './PostConversation.scss'
import { isFulfilled, isRejected } from '@reduxjs/toolkit'
import { useToasts } from 'react-toast-notifications'
import { TOAST_MESSAGE } from '../../UI/ToastNotification/ToastNotification'
import { defineAvailablePostsActions } from '../../../models/postStatuses'
import { TUser } from '../../../models'
import { SCHEDULE_ACTION_TYPES } from '../../../store/application/types'
import TrashIcon from '../../UI/Icons/Trash'
import Roles from '../../../models/roles'
import { SETTING_NAME } from '../../../store/project/types'
import Lightbox from 'react-image-lightbox'
import { APPROVAL_LIST_TYPE } from '../../../store/application/types'
import { Interface } from 'readline'

interface PostConversationProps { }

interface CheckBoxInterface {
  label: string
  isChecked: boolean
  disabled: boolean
  ref: React.RefObject<HTMLInputElement>
}

enum POST_CONVERSTION_VIEW_TABS {
  VIEW_APPROVAL = 'Approval',
  VIEW_ACTIVITY = 'Activity',
  VIEW_NOTES = 'Notes'
}

enum INPUT_LIST_TYPE {
  TYPE_CHECKBOX = 'checkbox',
  TYPE_NOTE = 'note'
}

interface SelectorInterface {
  postId: number
  selectedPostSocialId: number
  postSocialsApprovalActions: TPostSocialsActionsMapByPostSocialId
  approvalPlan: TApprovalPlan | null
  location: any
  postStatus: any
  user: TUser | null
  postSocialNotes: TPostSocialsNotesMapByPostSocialId
  postSocials: TPostSocialManagePost[]
  loaders: TLoadersManagePost
  postSocialsApprovalPlan: TApprovalPostSocialsManagePost[],
  projectId:number
  approvalListType:string
}

const PostConversation: FC<PostConversationProps> = () => {
  const dispatch = useDispatch()
  const [postConverstionViewTab, setPostConverstionViewTab] = useState<POST_CONVERSTION_VIEW_TABS>(
    POST_CONVERSTION_VIEW_TABS.VIEW_APPROVAL
  )

  const [isHiddenInternalRoundBlock, setIsHiddenInternalRoundBlock] = useState<boolean>(false)

  const [requireRevisionMessage, setRequireRevisionMessage] = useState<string>('')
  const [checkboxes, setCheckboxes] = useState<CheckBoxInterface[]>([])

  const [openCheckboxInput, setOpenCheckboxInput] = useState<boolean>(false)
  const [checkboxText, setCheckboxText] = useState<string>('')

  const [noteText, setNoteText] = useState<string>('')
  const [notes, setNotes] = useState<TPostSocialNoteForList[]>([])

  const [inputTextForNoteOrCheckboxEdit, setInputTextForNoteOrCheckboxEdit] = useState<string>('')
  const [chosenInputForEditIndex, setChosenInputForEditIndex] = useState<number>(-1)
  const [attachments, setAttachments] = useState<Array<any>>([])
  const [notesAttachments, setNotesAttachments] = useState<Array<any>>([])
  const [editNotesAttachments, setEditNotesAttachments] = useState<Array<any>>([])
  const [showAttachImage, setShowAttachImage] = useState<string>('')
  const [isEditableModeStatus, setIsEditableModeStatus] = useState<any>({
    [`${APPROVAL_TYPE.TYPE_INTERNAL}`]: {},
    [`${APPROVAL_TYPE.TYPE_EXTERNAL}`]: {}
  })

  const ability = useContext(AbilityContext)
  const { can, rules } = new AbilityBuilder(Ability)
  const acceptedAttachment = 'image/*'

  const {
    postId,
    selectedPostSocialId,
    postSocialsApprovalActions,
    postStatus,
    approvalPlan,
    postSocialNotes,
    postSocials,
    postSocialsApprovalPlan,
    user,
    loaders,
    projectId,
    approvalListType,
    location
  }: SelectorInterface = useSelector(
    ({
      router: { location },
      auth: { user },
      managePost: {
        approval: { approval_plan: approvalPlan, post_socials: postSocialsApprovalPlan },
        selectedPostSocialId,
        post: { status: postStatus, id: postId },
        postSocialNotes,
        postSocialsApprovalActions,
        postSocials,
        loaders
      },
        project:{
          currentProject:{
            id:projectId
          }
      },
      app:{approvalListType}
    }) => {
      return {
        user,
        postId,
        selectedPostSocialId,
        postSocialsApprovalActions,
        approvalPlan,
        postStatus,
        location,
        postSocialNotes,
        postSocialsApprovalPlan,
        postSocials,
        loaders,
        projectId,
        approvalListType
      }
    }
  )
  const { addToast } = useToasts()
  const [isContentManager, setIsContentManager] = useState<boolean>(false);

  useEffect(() => {
    if (selectedPostSocialId && postSocialNotes[selectedPostSocialId]) {
      const notesWithRef: TPostSocialNoteForList[] = postSocialNotes[selectedPostSocialId].map(
        (note: TPostSocialNote) => ({
          ...note,
          disabled: true,
          ref: createRef()
        })
      )
      setNotes(notesWithRef)
    }
  }, [selectedPostSocialId, postSocialNotes, dispatch])

  useEffect(() => {
    if (user?.agency_role === Roles.CONTENT_CREATOR && user?.projects && projectId) {
      if (
        !!user.projects
          .find((v) => v.id === projectId)
          ?.setting.find((v) => v.name === SETTING_NAME.CONTENT_MANAGER && v.value === 'true')
      ) {
        for (let rule of ability.rules) {
          can(rule.action, rule.subject)
        }
        can('makeRevision', 'Post')
        ability.update(rules)
      }
    }
  }, [user, projectId])

  useEffect(() => {
    setChosenInputForEditIndex(-1)
  }, [selectedPostSocialId])
  useEffect(() => {
    setEditableModeArrayObject()
  }, [postSocialsApprovalActions[selectedPostSocialId]])

  const setEditableModeArrayObject = () => {
    if (!!postSocialsApprovalActions[selectedPostSocialId]) {
      let dummyEditableModeStatus = {
        [`${APPROVAL_TYPE.TYPE_INTERNAL}`]: {},
        [`${APPROVAL_TYPE.TYPE_EXTERNAL}`]: {}
      }
      postSocialsApprovalActions[selectedPostSocialId][APPROVAL_TYPE.TYPE_INTERNAL]?.map(
        (item, index) => {
          const preItem = dummyEditableModeStatus[`${APPROVAL_TYPE.TYPE_INTERNAL}`]
          dummyEditableModeStatus = {
            ...dummyEditableModeStatus,
            [`${APPROVAL_TYPE.TYPE_INTERNAL}`]: {
              ...preItem,
              [`${item.id}`]: false
            }
          }
        }
      )
      postSocialsApprovalActions[selectedPostSocialId][APPROVAL_TYPE.TYPE_EXTERNAL]?.map(
        (item, index) => {
          const preItem = dummyEditableModeStatus[`${APPROVAL_TYPE.TYPE_EXTERNAL}`]
          dummyEditableModeStatus = {
            ...dummyEditableModeStatus,
            [`${APPROVAL_TYPE.TYPE_EXTERNAL}`]: {
              ...preItem,
              [`${item.id}`]: false
            }
          }
        }
      )

      setIsEditableModeStatus(dummyEditableModeStatus)
    }
  }
  const isAvailableReschedule: boolean = useMemo(
    () => defineAvailablePostsActions.schedule(postStatus),
    [postStatus]
  )

  const isAvailablePublishNow = useMemo(
    () =>
      defineAvailablePostsActions.publishNow(postStatus) ||
      defineAvailablePostsActions.publishByAdmin(postStatus, user?.agency_role),
    [postStatus]
  )

  const isAvailableRequestRevision = useMemo(() => {
    if (postSocials.length) {
      const findedSocial = postSocials.find(({ id }) => id === selectedPostSocialId)!
      if (findedSocial && user) {
        const { status, is_approved } = findedSocial
        return (
          (approvalListType === APPROVAL_LIST_TYPE.PENDING && (user.agency_role === Roles.EXTERNAL_APPROVER ?
            POST_SOCIAL_STATUS.STATUS_PENDING_EXTERNAL_APPROVAL === status :
            POST_SOCIAL_STATUS.STATUS_PENDING_INTERNAL_APPROVAL === status)) || (is_approved && approvalListType === APPROVAL_LIST_TYPE.APPROVED)

        )
      }
    }
    return false
  }, [postSocials, selectedPostSocialId,approvalListType])

  const addCheckbox = () => {
    const newCheckBox: CheckBoxInterface = {
      label: checkboxText,
      isChecked: false,
      disabled: true,
      ref: createRef<HTMLInputElement>()
    }
    setCheckboxes((prev) => [...prev, newCheckBox])
    setCheckboxText('')
  }

  const deleteItemFromList = async (index: number, typeOfInput: INPUT_LIST_TYPE) => {
    switch (typeOfInput) {
      case INPUT_LIST_TYPE.TYPE_CHECKBOX:
        setCheckboxes((prev) => {
          const localCopy = [...prev]
          localCopy.splice(index, 1)
          return localCopy
        })
        break
      case INPUT_LIST_TYPE.TYPE_NOTE:
        try {
          const payload: TPostSocialNoteDeletedDataPayload = {
            note_id: notes[index].id,
            post_social_id: notes[index].post_social_id
          }
          await dispatch(deletePostSocialNoteThunk(payload))
          setEditNotesAttachments([])
        } catch (e) {
          console.error(e)
        }
        break
    }
  }

  const changeDisableStatusOfInputInList = async (index: number, typeOfInput: INPUT_LIST_TYPE) => {
    switch (typeOfInput) {
      case INPUT_LIST_TYPE.TYPE_CHECKBOX:
        const tempCheckboxes: CheckBoxInterface[] = checkboxes
        tempCheckboxes[index].disabled = !tempCheckboxes[index].disabled

        if (!tempCheckboxes[index].disabled) {
          setInputTextForNoteOrCheckboxEdit(tempCheckboxes[index].label)
          setChosenInputForEditIndex(index)
          setTimeout(() => {
            tempCheckboxes[index].ref.current?.focus()
          }, 0)
        } else {
          tempCheckboxes[index].label = inputTextForNoteOrCheckboxEdit
          setChosenInputForEditIndex(-1)
          setInputTextForNoteOrCheckboxEdit('')
        }
        setCheckboxes([...tempCheckboxes])
        break
      case INPUT_LIST_TYPE.TYPE_NOTE:
        const tempNotes: TPostSocialNoteForList[] = notes
        tempNotes[index].disabled = !tempNotes[index].disabled

        if (!tempNotes[index].disabled) {
          setInputTextForNoteOrCheckboxEdit(tempNotes[index].message!)
          setChosenInputForEditIndex(index)
          setTimeout(() => {
            tempNotes[index].ref?.current?.focus()
          }, 0)
          setNotes([...tempNotes])
        } else {
          const payload: TPostSocialNoteUpdatedDataPayload = {
            note_id: tempNotes[index].id,
            post_social_id: tempNotes[index].post_social_id,
            message: inputTextForNoteOrCheckboxEdit,
            attachments: editNotesAttachments
          }
          await dispatch(updateSocialPostNoteThunk(payload))
          setEditNotesAttachments([])
          setChosenInputForEditIndex(-1)
          setInputTextForNoteOrCheckboxEdit('')
        }

        break
    }
  }

  const sendRequireRevisionFromApprover = async () => {
    const masterContentSocial = postSocialsApprovalPlan.find(
      (socialPlan) => socialPlan.is_master_content
    )
    let approverId;
    let type;
    const findedSocial = postSocialsApprovalPlan.find(({ id }) => id === selectedPostSocialId)!
    if(findedSocial && findedSocial.is_approved && approvalListType === APPROVAL_LIST_TYPE.APPROVED){
      const { external_approval_id,internal_approval_id } = findedSocial
      approverId =  Number(user?.agency_role === Roles.EXTERNAL_APPROVER? external_approval_id:internal_approval_id)
      type = APPROVAL_LIST_TYPE.APPROVED;
    }else{
      approverId = postSocialsApprovalActions[selectedPostSocialId].lastApprovalId 
      type = APPROVAL_LIST_TYPE.PENDING
    }
    let payload: TRequireApproverRevisionPayload = {
      approval_id: approverId,
      message: requireRevisionMessage,
      checkboxes: checkboxes.map(({ label, isChecked }) => ({ label, is_checked: isChecked })),
      post_social_id: selectedPostSocialId,
      post_id: postId,
      isMasterContent: !!masterContentSocial,
      attachments:attachments,
      type: type
    }
    const data = await dispatch(requireApproverRevisionThunk(payload))
    if (isFulfilled(data)) {
      setAttachments([])
      addToast(TOAST_MESSAGE.REVISION_REQUESTED, { appearance: 'success' })
    } else if (isRejected(data)) {
      addToast(TOAST_MESSAGE.GENERAL_ERROR_MASSEGE, { appearance: 'error' })
    }
    setRequireRevisionMessage('')
    setCheckboxes([])
  }

  const changeCheckboxStatus = async (
    status: boolean,
    checkboxId: number,
    actionId: number,
    approvalId: number
  ) => {
    const payload: TStatusesCheckboxesPayload = {
      approval_action_id: actionId,
      approval_id: approvalId,
      checkboxes: [
        {
          id: checkboxId,
          is_checked: status
        }
      ],
      post_social_id: selectedPostSocialId
    }
    await dispatch(addStatusesToCheckboxesInRevisionBlockThunk(payload))
  }

  const deleteImage = async (indivisualAttachmentObject: any) => {
    const data = { ...indivisualAttachmentObject }
    return await dispatch(deleteNotesAttachment(data))
  }

  const sendNote = async () => {
    const payload: TNewPostSocialNotePayload = {
      post_social_id: selectedPostSocialId,
      message: noteText,
      attachments: notesAttachments
    }
    const data = await dispatch(savePostSocialNoteThunk(payload))
    if (isFulfilled(data)) {
      setNotesAttachments([])
      // addToast(TOAST_MESSAGE.NOTE_SENT, { appearance: 'success' })
    } else if (isRejected(data)) {
      addToast(TOAST_MESSAGE.GENERAL_ERROR_MASSEGE, { appearance: 'error' })
    }
    setNoteText('')
  }

  const schedulePost = () => {
    dispatch(openSchedulePostModal(SCHEDULE_ACTION_TYPES.SINGLE_SCHEDULE))
  }

  const publishPostManually = async () => {
    let data
    if (defineAvailablePostsActions.publishByAdmin(postStatus, user?.agency_role)) {
      data = await dispatch(adminPublishPostManuallyThunk())
    } else {
      data = await dispatch(publishPostManuallyThunk())
    }
    if (isFulfilled(data)) {
      addToast(TOAST_MESSAGE.THE_CONTENT_HAS_BEEN_SUCCESSFULLY_PUBLISHED, { appearance: 'success' })
    } else if (isRejected(data)) {
      addToast(TOAST_MESSAGE.THE_CONTENT_HAS_NOT_BEEN_PUBLISHED, { appearance: 'error' })
    }
  }

  const isApproved = useCallback(
    (type: ACTION_TYPE) =>
      type === ACTION_TYPE.TYPE_APPROVED ||
      type === ACTION_TYPE.TYPE_APPROVED_BY_ADMIN ||
      type === ACTION_TYPE.TYPE_APPROVED_BY_SYSTEM,
    []
  )

  const attachFiles = (event: any, attachment: Array<any>, setAttachment: any) => {
    const {
      target: { files }
    } = event
    const attachmentFiles = [...attachment]
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        attachmentFiles.push(files[i])
      }
    }
    setAttachment(attachmentFiles)
  }

  const deleteAttachment = (index: number, attachment: Array<any>, setAttachment: any) => {
    const attachmentFiles = [...attachment]
    attachmentFiles.splice(index, 1)
    setAttachment(attachmentFiles)
  }

  const removeImage = async (attachmentData: any) => {
    const data = await dispatch(
      removeAttachmentThunk({
        post_social_id: selectedPostSocialId,
        attachmentId: attachmentData.id
      })
    )
    if (isFulfilled(data)) {
      await dispatch(showAllPostSocialNoteThunk(selectedPostSocialId))
      addToast(TOAST_MESSAGE.ATTCHMENT_REMOVED, { appearance: 'success' })
    } else if (isRejected(data)) {
      addToast(TOAST_MESSAGE.GENERAL_ERROR_MASSEGE, { appearance: 'error' })
    }
  }

  const viewAttachment = (image: string): void => {
    setShowAttachImage(image)
  }

  const onCloseAttachment = (): void => {
    setShowAttachImage('')
  }
  const setEditableMode = (approvalType: string, actionId: number | string) => {
    setIsEditableModeStatus({
      ...isEditableModeStatus,
      [`${approvalType}`]: {
        ...isEditableModeStatus[`${approvalType}`],
        [actionId]: !isEditableModeStatus[`${approvalType}`][`${actionId}`]
      }
    })
  }

  const isContentCreator = useMemo(() => user?.agency_role === Roles.CONTENT_CREATOR, [user])

  useEffect(() => {
    const role_name = user?.projects?.find(v=>v.id === projectId)?.setting.find(v=>v.name === SETTING_NAME.CONTENT_MANAGER && v.value === 'true')?.name;
    if(role_name !== null && role_name === 'content-manager'){
      setIsContentManager(true);
    }
  }, [user]);

  return (
    <>
      {approvalPlan || postStatus === 'draft' ? (
        <div className='post-conversation'>
          <div className='post-conversation-header__view-navigation__button-wrapper'>
            <button
              className={`${postConverstionViewTab === POST_CONVERSTION_VIEW_TABS.VIEW_NOTES && 'active'
                }`}
              onClick={() => setPostConverstionViewTab(POST_CONVERSTION_VIEW_TABS.VIEW_NOTES)}
            >
              {POST_CONVERSTION_VIEW_TABS.VIEW_NOTES}
            </button>
            <button
              className={`${postConverstionViewTab === POST_CONVERSTION_VIEW_TABS.VIEW_ACTIVITY && 'active'
                }`}
              onClick={() => setPostConverstionViewTab(POST_CONVERSTION_VIEW_TABS.VIEW_ACTIVITY)}
            >
              {POST_CONVERSTION_VIEW_TABS.VIEW_ACTIVITY}
            </button>
            <button
              className={`${postConverstionViewTab === POST_CONVERSTION_VIEW_TABS.VIEW_APPROVAL && 'active'
                }`}
              onClick={() => setPostConverstionViewTab(POST_CONVERSTION_VIEW_TABS.VIEW_APPROVAL)}
            >
              {POST_CONVERSTION_VIEW_TABS.VIEW_APPROVAL}
            </button>
          </div>
          {loaders.approval.loading ? (
            <Preloader />
          ) : (
            <>
              {/* notes tab */}
              <div
                className={`post-conversation-tab ${postConverstionViewTab !== POST_CONVERSTION_VIEW_TABS.VIEW_NOTES &&
                  'post-conversation-tab_invisible'
                  }`}
              >
                <div className='post-notes-wrapper'>
                  {!!notes.length &&
                    notes.map(
                      (
                        { message, id: noteId, updated_at: updatedAt, disabled, ref, attachments },
                        index
                      ) => (
                        <PostActionWrapper
                          actionType={null}
                          key={`${noteId}_note_tab_${message}`}
                          typeOfMark={MARK_TYPE.TYPE_MARK}
                          datetime={updatedAt}
                        >
                          <div className='post-checkbox-container'>
                            <TextareaAutosize
                              ref={(tag) => (ref.current = tag)}
                              className='post-checkbox_input'
                              disabled={disabled}
                              maxLength={1000}
                              value={
                                inputTextForNoteOrCheckboxEdit && chosenInputForEditIndex === index
                                  ? inputTextForNoteOrCheckboxEdit
                                  : message!
                              }
                              onChange={({ target: { value } }) =>
                                setInputTextForNoteOrCheckboxEdit(value)
                              }
                            />
                            <div className='post-checkbox_actions'>
                              {disabled ? (
                                <img
                                  className='post-note_icon post-note_icon_edit'
                                  src={EditIcon}
                                  onClick={() =>
                                    changeDisableStatusOfInputInList(
                                      index,
                                      INPUT_LIST_TYPE.TYPE_NOTE
                                    )
                                  }
                                  alt=''
                                />
                              ) : (
                                <>
                                  <div className='wrap-icon'>
                                    <label>
                                      <img className='attachment-edit' src={AttachmentIcon} />
                                      <input
                                        id='attachment-upload'
                                        style={{ display: 'none' }}
                                        type='file'
                                        multiple
                                        accept={acceptedAttachment}
                                        onChange={($event) =>
                                          attachFiles(
                                            $event,
                                            editNotesAttachments,
                                            setEditNotesAttachments
                                          )
                                        }
                                      />
                                    </label>
                                  </div>
                                  <img
                                    className='post-note_icon post-note_icon_edit'
                                    src={CheckCircle}
                                    onClick={() =>
                                      changeDisableStatusOfInputInList(
                                        index,
                                        INPUT_LIST_TYPE.TYPE_NOTE
                                      )
                                    }
                                    alt=''
                                  />
                                </>
                              )}
                              <CustomButton
                                button='delete'
                                className='post-note__button-delete'
                                inProgress={
                                  loaders.note.delete && loaders.note.processingIds.includes(noteId)
                                }
                                onClick={() => deleteItemFromList(index, INPUT_LIST_TYPE.TYPE_NOTE)}
                              >
                                {!(
                                  loaders.note.delete && loaders.note.processingIds.includes(noteId)
                                ) && <TrashIcon />}
                              </CustomButton>
                            </div>
                          </div>
                          {(attachments && attachments.length > 0) ||
                            (editNotesAttachments &&
                              editNotesAttachments.length > 0 &&
                              inputTextForNoteOrCheckboxEdit &&
                              chosenInputForEditIndex === index) ? (
                            <div className='thumbnail'>
                              <ul>
                                {attachments &&
                                  attachments.length > 0 &&
                                  attachments.map((v) => (
                                    <li>
                                      {inputTextForNoteOrCheckboxEdit &&
                                        chosenInputForEditIndex === index && (
                                          <div
                                            className='image-actions_remove notes'
                                            onClick={() => removeImage(v)}
                                          >
                                            <TrashIcon />
                                          </div>
                                        )}
                                      <img
                                        src={v.object_data.public_url}
                                        onClick={() => viewAttachment(v.object_data.public_url)}
                                      />
                                    </li>
                                  ))}
                                {editNotesAttachments &&
                                  editNotesAttachments.length > 0 &&
                                  inputTextForNoteOrCheckboxEdit &&
                                  chosenInputForEditIndex === index &&
                                  editNotesAttachments.map((v: any, k: number) => (
                                    <li>
                                      <div
                                        className='image-actions_remove notes'
                                        onClick={() =>
                                          deleteAttachment(
                                            k,
                                            editNotesAttachments,
                                            setEditNotesAttachments
                                          )
                                        }
                                      >
                                        <TrashIcon />
                                      </div>
                                      <img
                                        src={URL.createObjectURL(v)}
                                        onClick={() => viewAttachment(URL.createObjectURL(v))}
                                      />
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          ) : null}
                        </PostActionWrapper>
                      )
                    )}
                  {!notes.length && (
                    <div className='post-notes-wrapper__empty-post-data'>
                      <div className='post-notes-wrapper__empty-post-data__cover cover-empty-notes' />
                      <div className='post-notes-wrapper__empty-post-data__text'>
                        You don’t have any notes now
                      </div>
                    </div>
                  )}
                </div>
                {!!postId && (
                  <>
                    <div className='post-action-wrapper'>
                      <div className='post-input-container'>
                        <textarea
                          rows={3}
                          className='post-input-container_input'
                          value={noteText}
                          maxLength={1000}
                          onChange={({ target: { value } }) => setNoteText(value)}
                          placeholder='Write note...'
                        />
                        <div className='wrap-icon'>
                          <label>
                            <img className='attachment' src={AttachmentIcon} />
                            <input
                              id='attachment-upload'
                              style={{ display: 'none' }}
                              type='file'
                              multiple
                              accept={acceptedAttachment}
                              onChange={($event) =>
                                attachFiles($event, notesAttachments, setNotesAttachments)
                              }
                            />
                          </label>
                        </div>
                        <CustomButton
                          onClick={sendNote}
                          inProgress={loaders.note.save}
                          button='primary'
                          type='button'
                        >
                          Add
                        </CustomButton>
                      </div>
                    </div>
                    {notesAttachments && notesAttachments.length > 0 ? (
                      <div className='thumbnail'>
                        <ul>
                          {notesAttachments.map((v, k) => (
                            <li>
                              <div
                                className='image-actions_remove'
                                onClick={() =>
                                  deleteAttachment(k, notesAttachments, setNotesAttachments)
                                }
                              >
                                <TrashIcon />
                              </div>
                              <img
                                className='img-view'
                                src={URL.createObjectURL(v)}
                                onClick={() => viewAttachment(URL.createObjectURL(v))}
                              />
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
              {/* notes tab */}

              {/* activity tab */}
              <div
                className={`post-conversation-tab ${postConverstionViewTab !== POST_CONVERSTION_VIEW_TABS.VIEW_ACTIVITY &&
                  'post-conversation-tab_invisible'
                  }`}
              >
                <div
                  className={`post-notes-wrapper ${postSocialsApprovalActions[selectedPostSocialId]}`}
                >
                  <Can I='seeInternalApprovalRound' a='Post'>
                    <>
                      {!!postSocialsApprovalActions[selectedPostSocialId]?.[
                        APPROVAL_TYPE.TYPE_INTERNAL
                      ].length &&
                        postSocialsApprovalActions[selectedPostSocialId][
                          APPROVAL_TYPE.TYPE_INTERNAL
                        ].map(({ type, id: actionId, created_at: createdAt, created_by_user }) => (
                          <PostActionWrapper
                            actionType={null}
                            key={`${actionId}_activity_tab`}
                            typeOfMark={
                              isApproved(type) ? MARK_TYPE.TYPE_CHECK_MARK : MARK_TYPE.TYPE_MARK
                            }
                            datetime={createdAt}
                          >
                            <PostActionTitle
                              from={created_by_user?.name || null}
                              type={type}
                              avatar={created_by_user?.avatar_image_link || null}
                              isEditableMode={
                                isEditableModeStatus[`${APPROVAL_TYPE.TYPE_INTERNAL}`][
                                `${actionId}`
                                ]
                              }
                              setIsEditableMode={() =>
                                setEditableMode(APPROVAL_TYPE.TYPE_INTERNAL, actionId)
                              }
                            />
                          </PostActionWrapper>
                        ))}
                    </>
                  </Can>
                  {!!postSocialsApprovalActions[selectedPostSocialId]?.[APPROVAL_TYPE.TYPE_EXTERNAL]
                    .length &&
                    postSocialsApprovalActions[selectedPostSocialId][
                      APPROVAL_TYPE.TYPE_EXTERNAL
                    ].map(({ type, id: actionId, created_at: createdAt, created_by_user }) => (
                      <PostActionWrapper
                        actionType={null}
                        key={`${actionId}_activity_tab`}
                        typeOfMark={
                          isApproved(type) ? MARK_TYPE.TYPE_CHECK_MARK : MARK_TYPE.TYPE_MARK
                        }
                        datetime={createdAt}
                      >
                        <PostActionTitle
                          from={created_by_user?.name || null}
                          type={type}
                          avatar={created_by_user?.avatar_image_link || null}
                          isEditableMode={
                            isEditableModeStatus[`${APPROVAL_TYPE.TYPE_EXTERNAL}`][`${actionId}`]
                          }
                          setIsEditableMode={() =>
                            setEditableMode(APPROVAL_TYPE.TYPE_EXTERNAL, actionId)
                          }
                        />
                      </PostActionWrapper>
                    ))}
                  {(!postSocialsApprovalActions[selectedPostSocialId] ||
                    !postSocialsApprovalActions[selectedPostSocialId].aprrovalActions.length) && (
                      <div className='post-notes-wrapper__empty-post-data'>
                        <div className='post-notes-wrapper__empty-post-data__cover cover-empty-notes' />
                        <div className='post-notes-wrapper__empty-post-data__text'>
                          You don’t have any activities now
                        </div>
                      </div>
                    )}
                </div>
              </div>
              {/* activity tab */}

              {/* approval tab */}
              <div
                className={`post-conversation-tab ${postConverstionViewTab !== POST_CONVERSTION_VIEW_TABS.VIEW_APPROVAL &&
                  'post-conversation-tab_invisible'
                  }`}
              >
                <div className='post-conversation-actions-container'>
                  <Can I='seeInternalApprovalRound' a='Post'>
                    {postSocialsApprovalActions[selectedPostSocialId] &&
                      postSocialsApprovalActions[selectedPostSocialId][APPROVAL_TYPE.TYPE_INTERNAL]
                        .length ? (
                      <>
                        <div className='post-approval-wrapper'>
                          <div className='post-approval-round-title'>Internal round</div>
                          <div
                            className={`post-approval-internal ${isHiddenInternalRoundBlock && 'post-approval-internal-hide'
                              }`}
                          >
                            {postSocialsApprovalActions[selectedPostSocialId][
                              APPROVAL_TYPE.TYPE_INTERNAL
                            ].map(
                              (
                                {
                                  message,
                                  type,
                                  checkboxes,
                                  id: actionId,
                                  approval_id: approvalId,
                                  created_at: createdAt,
                                  created_by_user,
                                  attachments
                                },
                                index
                              ) =>
                                type !== ACTION_TYPE.TYPE_QUESTION_PUSHED &&
                                type !== ACTION_TYPE.TYPE_ANSWER_PUSHED && (
                                  <PostActionWrapper
                                    actionType={type}
                                    key={actionId}
                                    typeOfMark={
                                      isApproved(type)
                                        ? MARK_TYPE.TYPE_CHECK_MARK
                                        : MARK_TYPE.TYPE_MARK
                                    }
                                    datetime={createdAt}
                                  >
                                    <PostActionTitle
                                      from={created_by_user?.name || null}
                                      type={type}
                                      avatar={created_by_user?.avatar_image_link || null}
                                      shouldEnableEdit
                                      isEditableMode={
                                        isEditableModeStatus[`${APPROVAL_TYPE.TYPE_INTERNAL}`][
                                        `${actionId}`
                                        ]
                                      }
                                      setIsEditableMode={() =>
                                        setEditableMode(APPROVAL_TYPE.TYPE_INTERNAL, actionId)
                                      }
                                      shouldShowEditIcon={
                                        index ==
                                        postSocialsApprovalActions[selectedPostSocialId][
                                          APPROVAL_TYPE.TYPE_INTERNAL
                                        ].length -
                                        1 && ((checkboxes || []).length > 0 || (message || "").length > 0) && (created_by_user.id == user?.id)
                                      }
                                    />
                                    {(type === ACTION_TYPE.TYPE_REVISION_REQUESTED || type ===ACTION_TYPE.TYPE_UNAPPROVED) && (
                                      <PostActionBody
                                        message={message}
                                        checkboxes={checkboxes}
                                        approvalId={approvalId}
                                        attachments={attachments}
                                        isEditableMode={
                                          isEditableModeStatus[`${APPROVAL_TYPE.TYPE_INTERNAL}`][
                                          `${actionId}`
                                          ]
                                        }
                                        setIsEditableMode={() =>
                                          setEditableMode(APPROVAL_TYPE.TYPE_INTERNAL, actionId)
                                        }
                                        questionAnswerHistory={
                                          postSocialsApprovalActions[selectedPostSocialId]
                                            .questionAnswerHistoryByApprovalId[approvalId]
                                        }
                                        checkBoxOnChangeStatus={(
                                          status: boolean,
                                          checkboxId: number
                                        ) =>
                                          changeCheckboxStatus(
                                            status,
                                            checkboxId,
                                            actionId,
                                            approvalId
                                          )
                                        }
                                        selectedPostSocialId={selectedPostSocialId}
                                        deleteImage={deleteImage}
                                        actionId={actionId}
                                      />
                                    )}
                                  </PostActionWrapper>
                                )
                            )}
                          </div>
                        </div>
                        <div className='post-action_content-body-question mb-20'>
                          <div
                            className='question-container_button'
                            onClick={() =>
                              setIsHiddenInternalRoundBlock(!isHiddenInternalRoundBlock)
                            }
                          >
                            {isHiddenInternalRoundBlock
                              ? 'See all internal round'
                              : 'Hide all internal round'}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className='post-notes-wrapper__empty-post-data'>
                        <div className='post-notes-wrapper__empty-post-data__cover cover-empty-approval' />
                        <div className='post-notes-wrapper__empty-post-data__text'>
                          You don’t have any approval actions now
                        </div>
                      </div>
                    )}
                  </Can>
                  {postSocialsApprovalActions[selectedPostSocialId] &&
                    postSocialsApprovalActions[selectedPostSocialId][APPROVAL_TYPE.TYPE_EXTERNAL]
                      .length ? (
                    <>
                      <div className='post-approval-wrapper'>
                        <div className='post-approval-round-title'>External round</div>
                        <div className='post-approval-internal'>
                          {postSocialsApprovalActions[selectedPostSocialId][
                            APPROVAL_TYPE.TYPE_EXTERNAL
                          ].map(
                            (
                              {
                                message,
                                type,
                                checkboxes,
                                id: actionId,
                                approval_id: approvalId,
                                created_at: createdAt,
                                created_by_user,
                                attachments
                              },
                              index
                            ) =>
                              type !== ACTION_TYPE.TYPE_QUESTION_PUSHED &&
                              type !== ACTION_TYPE.TYPE_ANSWER_PUSHED && (
                                <PostActionWrapper
                                  actionType={type}
                                  key={actionId}
                                  typeOfMark={
                                    isApproved(type)
                                      ? MARK_TYPE.TYPE_CHECK_MARK
                                      : MARK_TYPE.TYPE_MARK
                                  }
                                  datetime={createdAt}
                                >
                                  <PostActionTitle
                                    from={created_by_user?.name || null}
                                    type={type}
                                    avatar={created_by_user?.avatar_image_link || null}
                                    shouldEnableEdit
                                    isEditableMode={
                                      isEditableModeStatus[`${APPROVAL_TYPE.TYPE_EXTERNAL}`][
                                      `${actionId}`
                                      ]
                                    }
                                    setIsEditableMode={() =>
                                      setEditableMode(APPROVAL_TYPE.TYPE_EXTERNAL, actionId)
                                    }
                                    shouldShowEditIcon={
                                      (index ==
                                        postSocialsApprovalActions[selectedPostSocialId][
                                          APPROVAL_TYPE.TYPE_EXTERNAL
                                        ].length -
                                        1) && (Boolean((checkboxes || []).length) || (message || "").length > 0) && (created_by_user.id == user?.id)
                                    }
                                  />
                                  {(type === ACTION_TYPE.TYPE_REVISION_REQUESTED || type ===ACTION_TYPE.TYPE_UNAPPROVED)  &&(
                                    <PostActionBody
                                      message={message}
                                      checkboxes={checkboxes}
                                      approvalId={approvalId}
                                      attachments={attachments}
                                      isEditableMode={
                                        isEditableModeStatus[`${APPROVAL_TYPE.TYPE_EXTERNAL}`][
                                        `${actionId}`
                                        ]
                                      }
                                      setIsEditableMode={() =>
                                        setEditableMode(APPROVAL_TYPE.TYPE_EXTERNAL, actionId)
                                      }
                                      selectedPostSocialId={selectedPostSocialId}
                                      questionAnswerHistory={
                                        postSocialsApprovalActions[selectedPostSocialId]
                                          .questionAnswerHistoryByApprovalId[approvalId]
                                      }
                                      checkBoxOnChangeStatus={(
                                        status: boolean,
                                        checkboxId: number
                                      ) =>
                                        changeCheckboxStatus(
                                          status,
                                          checkboxId,
                                          actionId,
                                          approvalId
                                        )
                                      }
                                      actionId={actionId}
                                      deleteImage={deleteImage}

                                    />
                                  )}
                                  {isApproved(type) && (
                                    <div className='post-action_content-body post-action-approved'>
                                      <CustomButton
                                        onClick={schedulePost}
                                        disabled={!isAvailableReschedule}
                                        button='secondary'
                                      >
                                        <WaitingIcon color={'#3a98ab'} /> Change Schedule
                                      </CustomButton>
                                      <CustomButton
                                        disabled={!isAvailablePublishNow}
                                        onClick={publishPostManually}
                                        button='primary'
                                      >
                                        <PublishIcon /> Publish now
                                      </CustomButton>
                                    </div>
                                  )}
                                </PostActionWrapper>
                              )
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  {postSocialsApprovalActions[selectedPostSocialId] &&
                    !postSocialsApprovalActions[selectedPostSocialId][APPROVAL_TYPE.TYPE_INTERNAL]
                      .length &&
                    !postSocialsApprovalActions[selectedPostSocialId][APPROVAL_TYPE.TYPE_EXTERNAL]
                      .length && (
                      <div className='post-notes-wrapper__empty-post-data'>
                        <div className='post-notes-wrapper__empty-post-data__cover cover-empty-approval' />
                        <div className='post-notes-wrapper__empty-post-data__text'>
                          Are you ready with the Facebook content?
                        </div>
                        <CustomButton
                          button='primary'
                          className='post-notes-wrapper__empty-post-data__send-to-approval'
                          onClick={() => console.log('check some value', postId)}
                          disabled={!postId}
                        >
                          Send content to approval
                        </CustomButton>
                      </div>
                    )}
                </div>

                <div className='post-action-wrapper'>
                  <div className='post-checkbox-wrapper'>
                    {checkboxes.map(({ label, isChecked, disabled, ref }, index) => (
                      <div className='post-checkbox-container my-10' key={label}>
                        <div className='post-checkbox_checkbox'>
                          <Checkbox checked={isChecked} />
                        </div>
                        <input
                          ref={ref}
                          className='post-checkbox_input pl-35'
                          disabled={disabled}
                          maxLength={255}
                          value={
                            inputTextForNoteOrCheckboxEdit && chosenInputForEditIndex === index
                              ? inputTextForNoteOrCheckboxEdit
                              : label
                          }
                          onChange={({ target: { value } }) =>
                            setInputTextForNoteOrCheckboxEdit(value)
                          }
                        />
                        <div className='post-checkbox_actions'>
                          {disabled ? (
                            <img
                              className='post-input-container_delete'
                              src={EditIcon}
                              onClick={() =>
                                changeDisableStatusOfInputInList(
                                  index,
                                  INPUT_LIST_TYPE.TYPE_CHECKBOX
                                )
                              }
                              alt=''
                            />
                          ) : (
                            <img
                              className='post-input-container_delete'
                              src={CheckCircle}
                              onClick={() =>
                                changeDisableStatusOfInputInList(
                                  index,
                                  INPUT_LIST_TYPE.TYPE_CHECKBOX
                                )
                              }
                              alt=''
                            />
                          )}
                          <img
                            className='post-input-container_delete'
                            src={TrashRed}
                            onClick={() => deleteItemFromList(index, INPUT_LIST_TYPE.TYPE_CHECKBOX)}
                            alt=''
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  {!!postSocialsApprovalActions[selectedPostSocialId] &&
                    isAvailableRequestRevision && (!isContentCreator || isContentManager) && (
                      <Can I='makeRevision' a='Post'>
                        <div className='post-input-container-wrapper'>
                          {openCheckboxInput ? (
                            <>
                              <div className='post-input-container'>
                                <input
                                  className='post-input-container_input'
                                  placeholder='Type here'
                                  value={checkboxText}
                                  maxLength={255}
                                  onChange={({ target: { value } }) => setCheckboxText(value)}
                                />
                                {checkboxText && (
                                  <>
                                    <img
                                      className='post-input-container_delete'
                                      src={DeleteIcon}
                                      onClick={() => setCheckboxText('')}
                                      alt=''
                                    />
                                    <div className='post-input-container_line'></div>
                                  </>
                                )}
                                <CustomButton
                                  onClick={addCheckbox}
                                  button='primary'
                                  disabled={!checkboxText}
                                  type='button'
                                >
                                  Add
                                </CustomButton>
                              </div>
                              <button
                                className={checkboxes.length >0?'post-input-container_button_primary':'post-input-container_button'}
                                onClick={() => setOpenCheckboxInput(false)}
                              >
                                {checkboxes.length >0?'Save':'Back'}
                              </button>
                            </>
                          ) : (
                            <div>
                              <div className='post-input-container'>
                                <textarea
                                  rows={3}
                                  className='post-input-container_input'
                                  maxLength={1000}
                                  value={requireRevisionMessage}
                                  onChange={({ target: { value } }) =>
                                    setRequireRevisionMessage(value)
                                  }
                                  placeholder='Write review...'
                                />
                                <div className='wrap-icon'>
                                  <img
                                    className='post-input-container_checkbox'
                                    src={CheckBoxIcon}
                                    onClick={() => setOpenCheckboxInput(true)}
                                    alt=''
                                  />
                                  <label>
                                    <img className='attachment' src={AttachmentIcon} />
                                    <input
                                      id='attachment-upload'
                                      style={{ display: 'none' }}
                                      type='file'
                                      multiple
                                      accept={acceptedAttachment}
                                      onChange={($event) =>
                                        attachFiles($event, attachments, setAttachments)
                                      }
                                    />
                                  </label>
                                </div>
                                <CustomButton
                                  onClick={sendRequireRevisionFromApprover}
                                  inProgress={loaders.approval.requestRevision}
                                  button='primary'
                                  type='button'
                                  className='post-input-container__request-revision-button'
                                >
                                  Request revision
                                </CustomButton>
                              </div>
                              {attachments && attachments.length > 0 ? (
                                <div className='thumbnail'>
                                  <ul>
                                    {attachments.map((v, k) => (
                                      <li>
                                        <div
                                          className='image-actions_remove'
                                          onClick={() =>
                                            deleteAttachment(k, attachments, setAttachments)
                                          }
                                        >
                                          <TrashIcon />
                                        </div>
                                        <img
                                          className='img-view'
                                          src={URL.createObjectURL(v)}
                                          onClick={() => viewAttachment(URL.createObjectURL(v))}
                                        />
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              ) : null}
                            </div>
                          )}
                        </div>
                      </Can>
                    )}
                </div>
              </div>
            </>
          )}
          {/* approval tab */}
        </div>
      ) : null}

      {showAttachImage ? (
        <Lightbox mainSrc={showAttachImage} onCloseRequest={onCloseAttachment} />
      ) : null}
    </>
  )
}
export default PostConversation
